export default __webpack_public_path__ + "static/media/badgeIconRed.77e6068f.svg";